<template>
  <!-- <el-breadcrumb class="app-breadcrumb" separator=">">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span v-if="item.redirect === 'noRedirect' || index == levelList.length - 1" class="no-redirect">
          {{ item.meta.title }}
        </span>
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb> -->
  <el-breadcrumb class="app-breadcrumb" separator=">">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span v-if="item.redirect === 'noRedirect' || index == levelList.length - 1" class="no-redirect">
          {{$t(item.meta.title) }}
        </span>
        <a v-else @click.prevent="handleLink(item)">{{ $t(item.meta.title) }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>
<script>
  import {
    generateTitle
  } from "@/utils/i18n";
  import pathToRegexp from "path-to-regexp";
  export default {
    data() {
      return {
        levelList: null,
        newRoute: {},
      };
    },
    watch: {
      // $route(route) {
      //   // if you go to the redirect page, do not update the breadcrumbs
      //   if (route.path.startsWith('/redirect/')) {
      //     return
      //   }
      //   this.getBreadcrumb()
      // }
      $route: function(to) {
        const {
          fullPath,
          matched
        } = to;
        // 全路径存储
        matched[matched.length - 1].fullPath = fullPath;
        // 保留上一次父级全路径
        const fromMatched = this.newRoute.matched;
        if (fromMatched && fromMatched.length < matched.length) {
          fromMatched.push(matched[matched.length - 1]);
          this.newRoute = {
            ...to,
            matched: fromMatched
          };
        } else {
          this.newRoute = {
            ...to,
            matched: matched
          };
        }
        // console.log(this.newRoute, "2323211xx");
      },
    },
    created() {
      this.getBreadcrumb();
    },
    methods: {
      generateTitle,
      getBreadcrumb() {
        // console.log(this.$route,'xxssw')
        // only show routes with meta.title
        let matched = this.$route.matched.filter(
          (item) => item.meta && item.meta.title);
        matched[matched.length - 1].fullPath = this.$route.fullPath;
        const first = matched[0];
        if (!this.isDashboard(first)) {
          matched = [{
            path: "/dashboard",
            meta: {
              title: this.$t('Navbar.home')
            }
          }].concat(matched);
        }
        // console.log(matched, "面包", this.$route);
        this.levelList = matched.filter(
          (item) => item.meta && item.meta.title && item.meta.breadcrumb !== false);
      },
      isDashboard(route) {
        const name = route && route.name;
        if (!name) {
          return false;
        }
        return (name.trim().toLocaleLowerCase() === "Dashboard".toLocaleLowerCase());
      },
      pathCompile(path) {
        // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
        const {
          params
        } = this.$route;
        var toPath = pathToRegexp.compile(path);
        return toPath(params);
      },
      handleLink(item) {
        console.log(item, "ggg");
        // return
        const {
          redirect,
          fullPath,
          path
        } = item;
        if (fullPath) {
          this.$router.push(fullPath);
          return;
        } else {
          this.$router.push(path);
        }
        // this.$router.push(this.pathCompile(path))
      },
    },
  };
</script>
<style lang="scss" scoped>
  @media (max-width: 480px) {
    .app-breadcrumb.el-breadcrumb {
      display: inline-block;
      font-size: 38px;
      line-height: 80px;
      margin-left: 14px;

      .no-redirect {
        color: #aabdd4;
        cursor: text;
        font-size: 38px;
      }

      .ant-breadcrumb .ant-breadcrumb-separator {
        font-size: 20px;
        /* 调整为所需的大小 */
      }

      a {
        color: #333;
        cursor: text;
        font-size: 38px;
      }
    }
  }

  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 8px;

    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
</style>